// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const CheckmarkCircleIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <path d="M15.667 0.333008V15.667H0.333008V0.333008H15.667Z" fill="white" stroke="white" strokeWidth="0.666667" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M8.00004 15.1667C4.04671 15.1667 0.833374 11.9533 0.833374 8.00001C0.833374 4.04668 4.04671 0.833344 8.00004 0.833344C11.9534 0.833344 15.1667 4.04668 15.1667 8.00001C15.1667 11.9533 11.9534 15.1667 8.00004 15.1667ZM8.00004 1.83334C4.60004 1.83334 1.83337 4.60001 1.83337 8.00001C1.83337 11.4 4.60004 14.1667 8.00004 14.1667C11.4 14.1667 14.1667 11.4 14.1667 8.00001C14.1667 4.60001 11.4 1.83334 8.00004 1.83334Z" fill={color || 'currentColor'} />
          <path d="M7.05331 10.3864C6.91997 10.3864 6.79331 10.3331 6.69998 10.2398L4.81333 8.35309C4.62 8.15975 4.62 7.83975 4.81333 7.64642C5.00667 7.45309 5.32667 7.45309 5.52 7.64642L7.05331 9.17975L10.48 5.75309C10.6733 5.55976 10.9933 5.55976 11.1866 5.75309C11.38 5.94643 11.38 6.26643 11.1866 6.45976L7.40664 10.2398C7.31331 10.3331 7.18664 10.3864 7.05331 10.3864Z" fill={color || 'currentColor'} />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { CheckmarkCircleIcon };
